export default "__VITE_ASSET__eee93185__"